import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'isThermostatSelected',
})
export class IsThermostatSelectedPipe implements PipeTransform {
  transform(thermostat: any, thermostats: any[]): boolean {
    return thermostats?.some((t) => t.id === thermostat.id) || false;
  }
}
